<template>
  <div class="avecor-table pa-2"  >
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar-title >
          {{this.label}}
        </v-toolbar-title>
      </v-col>
      <!-- <v-col cols="4" class="text-right ">
        <v-autocomplete
          v-if="allAccess && split && split === 'companies'"
          style=""
          label="Myyjä"
          :value="salespersonFilter"
          @change="v => salespersonFilter = v"
          :items="getSalespersons()"
          outlined
          dense
          item-text="firstName"
          item-value="id"
          class="avecor-select hide-field-details text-right mr-4"
        />
        

      </v-col> -->

    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="dataFiltered"
      hide-default-footer
      :hide-default-header="split !== 'productVariations' && split !== 'companies'"
      :sort-by="split === 'productVariations' ? ['avgMarg'] : ['total']"
      :sort-desc="[true]"
      ref="table"
      disable-pagination
      :expand="true"
      dense
    >
      <template v-slot:item="props">
        <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
        <tr style="height:33px;">
          <td class="" style="max-width:20px;margin-left:10px">
            {{props.index + 1}}
          </td>
          <td class="text-xs-left" :style="`${split === 'productVariations' ? 'min-width:150px;' : ''}max-width:200px`"><!-- min-width:70px; -->
            
            {{split === 'companies' ? props.item[firstColumnField] + ' (' +props.item.salespersonName +')' : '' }}
            {{split !== 'companies' ? props.item[firstColumnField] : '' }}
            <i v-if="props.item.isMarginCalculationActivated" class="fas fa-money-check-alt ml-1" style="color:green" ></i>
            
            <!-- isMarginCalculationActivated -->
            <!-- {{split === 'companies' && allAccess ? props.item[firstColumnField] + ' (' +props.item.salespersonName +')' : props.item[firstColumnField] }} -->
          </td>
          <td v-if="split === 'productVariations'">
            {{props.item.numberOfProducts}}
          </td>
          <td v-if="split === 'productVariations'">
            {{props.item.avgMarg ? props.item.avgMarg : 0}}
          </td>
          <td v-if="split === 'productVariations'">
            {{props.item.numberOfOrders}}
          </td>
          <td v-if="split === 'productVariations'">
            {{props.item.averagePrice}}
          </td>
          <td>
            {{props.item.total + (split === 'companies' || split === 'productVariations' ? ' €' : '')}}
            
          </td>

        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props: ['label','data','field', 'split'],
    data: () => ({
      salespersonFilter:null,
      isEditing: false,
      pagination: {'sortBy': 'total', 'descending': true, 'rowsPerPage': 15, sortable:true},
      
    }),
    watch: {
      allAccess:{
        handler(val){
          console.log(val)
          if(!this.allAccess) {
            this.salespersonFilter = this.user.uid
          }
          else this.salespersonFilter = 'all'
        }
      }
    },
    mounted() {
      if(!this.allAccess) {
        this.salespersonFilter = this.user.uid
      }
      else this.salespersonFilter = 'all'
    },
    computed: {
      headers(){
        var items = []
        items.push({ text: '', value: 'index', align: 'center', sortable: false })
        if(this.split === 'productVariations' || this.split === 'companies') items.push({ text: 'Nimi', value: 'name', align: 'left', sortable: false })
        else items.push({ text: 'Myyjä', value: 'firstName', align: 'left', sortable: false })
        if(this.split === 'productVariations') items.push({ text: 'Määrä', value: 'numberOfProducts', align: 'left', sortable: true })
        if(this.split === 'productVariations') items.push({ text: 'Katekerroin', value: 'avgMarg', align: 'left', sortable: true })
        if(this.split === 'productVariations') items.push({ text: 'Tilaukset', value: 'numberOfOrders', align: 'left', sortable: true })
        if(this.split === 'productVariations') items.push({ text: 'Keskihinta', value: 'averagePrice', align: 'left', sortable: true })
        items.push({ text: 'Myynti', value: 'total', align: 'left', sortable: true })
        return items
      },
      dataFiltered(){
        if(this.split && this.split === 'salespersons' && !this.allAccess){
          var list = this.data.sort((a,b) => {
            //console.log({a,b})
            if (a.total > b.total) {return -1;}
            if (a.total < b.total) {return 1;}
            return 0;
          })
          
          //var uid = 'GJ51vbQ1pLNNJMeKc4896QKdjVr1'
          var uid = this.user.uid
          var top3List = list.slice(0,3)
          var top3Array = top3List.map(item => {return item.id})
          //console.log({top3Array})
          list.forEach(row => {
            if(row.id === uid && !top3Array.includes(row.id)) top3List.push(row)
          })
          return top3List
        }  
        return this.data
      },
      firstColumnField(){
        return this.field ? this.field : 'firstName'
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      ...mapFields({
        user:"user",
        staff:"staff.staff"
      })
    },
    created () {
    },
    methods: {
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        salespersons.push({id:'all',firstName:'--Kaikki--' })
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) {
            salespersons.push({id:key,firstName:this.staff[key].firstName, })
          }
        }
        return salespersons
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/blocks/ReportTable.vue